import axios from 'axios';
import * as _ from 'lodash'

class AnttService {

  /**
   * Faz o vinculo de do RNTRC
   *
   * @returns Promise<Object> Status
   */
  vincularRntrc(request) {
    return axios.post('/v1/vincularRntrc', request);
  }
}

// Singleton
const instance = new AnttService();
export default instance;



// WEBPACK FOOTER //
// ./src/services/antt.js